<template>
  <div>
    <base-header type="gradient-success" class="pb-6">
    </base-header>
    <div class="container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-7">
            <label>Estado de las ordenes</label>
            <!--<base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-picker slot-scope="{focus, blur}"
                           @on-open="focus"
                           @on-close="blur"
                           :config="config"
                           class="form-control datepicker active_es"
                           v-model="date">
              </flat-picker>
            </base-input>-->

            <multiselect v-model="orderselect" :options="orderstatus" :searchable="false"
                           :close-on-select="true" :show-labels="false"
                           track-by="order_status_id" label="status"
                           placeholder="Seleccionar Estado"></multiselect>



          </div>
          <div class="col-5">
            <base-button class="mt-3" id="search" @click="search">Buscar</base-button>
          </div>
        </div>
        <div v-if="orders.length > 0">
          <div class="row text-right">
            <div class="col-12">
              <div>
                <base-button icon="fa fa-print" size="sm" @click="print" class="mt-3">Imprimir</base-button>
              </div>
            </div>
          </div>
          <div class="row mt-2" id="printMe">
            <div class="col-12">
              <table class="mt-3" width="100%" border="1px solid">
                <tr>
                  <td align="center"><h3>Producto</h3></td>
                  <td align="center"><h3>Compra</h3></td>
                  <td align="center"><h3>Unidad</h3></td>
                </tr>
                <tr v-for="(order,index) in orders" :key="index">
                  <td>{{ order.name }}</td>
                  <td>{{ order.Comprar }}</td>
                  <td>{{ order.unit }}</td>
                </tr>
              </table>
              <!--<b-table
                bordered hover
                :items="orders"
                :fields="fields"
                responsive="sm"
            >
            </b-table>-->
            </div>
          </div>
        </div>
        <div v-if="noresult">
          <span>No se encontraron resultados</span>
        </div>
        <div class="content-loading" id="content-loading">
          <div class="img-loading"></div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import {bus} from '../../components/Order/bus-order'
import {order_service} from '../../services/order/OrderService'
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
  name: '_blank',
  specs: [
    "fullscreen=yes",
    "titlebar=yes",
    "scrollbars=yes"
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "../scss/argon.scss"
  ]

}
Vue.use(VueHtmlToPaper, options);

export default {
  name: "Compras",
  data() {
    return {
      orderstatus:[],
      orderselect:'',
      date: '',
      mensaje: '',
      orders: [],
      noresult: false,
      config: {
        mode: "range",
        enableTime: true,
        dateFormat: "Y-m-d H:i:ss",
        allowInput: true,
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
            longhand: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
          },
          months: {
            shorthand: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Оct', 'Nov', 'Dic'],
            longhand: ['Enero', 'Febreo', 'Мarzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          },
        }
      },
      fields: [
        {
          label: 'Producto',
          key: 'name'
        },
        {
          label: 'Comprar',
          key: 'Comprar'
        },
        {
          label: 'Unidad',
          key: 'unit'
        }
      ]
    }
  },
  methods: {
    search: function () {
      //this.date = this.date.split(" to ")
      document.getElementById("content-loading").classList.add("active");
      if (this.orderselect.order_status_id > 0) {
        let data = {
          state:this.orderselect.order_status_id
        }
        order_service.GetAllComprasDate(data)
      }
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    },
  },
  created() {
    order_service.GetAllOrderStatus()
    bus.$on('GetAllComprasDate', (response) => {
      document.getElementById("content-loading").classList.add("inactive");
      if (response.length === 0) {
        this.noresult = true
        this.orders = []
      } else {
        this.noresult = false
        this.orders = response
      }
      console.log(response)
    })
    bus.$on('GetAllOrderStatus', (response) => {
      this.orderstatus = response
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.content-loading {
  position: relative;
}
</style>
